//mport store from '@/store'
import {calcularPrecioHospitalizacion} from '@/constantes/casos/hospitalizacion'

const obtenerTotalPagosPendientes = (servicios, calcularHospitalizacion = true) => {

  let total = 0;

  for(const i in servicios){

    const item = servicios[i]
    
    if(calcularHospitalizacion){
      calcularPrecioHospitalizacion(item)
    }

    if(item.total){
      total+=parseFloat(item.total);
    }else{
      console.log('item no tiene total;', item);
      
    }
    


  }

  return total;

} /*e.reduce( (a, b) => a + parseFloat(b.total), 0)*/


const obtenerServicioSinEvidencias = (servicios, calcularHospitalizacion = true) => {

  let total = 0;
  let lista = [];
  for(const i in servicios){

    delete servicios[i].evidencias;
    
    lista.push(servicios[i]);

  }

  return lista;

}

const obtenerTotalPagosRealizados = (e) =>e.reduce( (a, b) => a + parseFloat(b.monto), 0)
const obtenerTotalTicket = (pagosPendientes, pagosRealizados) => {
  return pagosPendientes - pagosRealizados;
}

const obtenerSaldoGenerado = (pagosPendientes, pagosRealizados) => {

  const total = obtenerTotalTicket(pagosPendientes,pagosRealizados)
  let res = "";

  switch(total){

    case 0:
      res = "Exacto"
      break;
    case total>0:
      res = "Positivo"
      break;
    default:
      res = "Negativo"
      break;

  }

  return res;

}

const obtenerDetallesPagosTicket = (pagosPendientes, pagosRealizados) => {
//prueba
  return {
    saldo:obtenerSaldoGenerado(pagosPendientes , pagosRealizados),
    total_pagos_pendientes:obtenerTotalPagosPendientes(pagosPendientes),
    total_pagos_realizados:obtenerTotalPagosRealizados(pagosRealizados),
  }

}

export {
    obtenerTotalPagosPendientes,
    obtenerTotalPagosRealizados,
    obtenerSaldoGenerado,
    obtenerTotalTicket,
    obtenerDetallesPagosTicket,
    obtenerServicioSinEvidencias
}


// WEBPACK FOOTER //
// ./src/constantes/saldo/index.js